<template>
  <v-app :theme="currentTheme">
    <router-view />
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters('theme', ['currentTheme'])
  },
  watch: {
    currentTheme(newTheme) {
      this.$vuetify.theme.global.name = newTheme
    }
  },
  mounted() {
    this.initTheme()
  },
  methods: {
    ...mapActions('theme', ['initTheme'])
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgb(var(--v-theme-on-background));
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: rgb(var(--v-theme-on-surface));
}

nav a.router-link-exact-active {
  color: rgb(var(--v-theme-primary));
}
</style>
